// Мини-приложение Telegram.
//
// Внутри Telegram виджет Login не работает в принципе — там приложение живёт
// в webview и получает подписанную `initData` через SDK. Это отдельный путь
// входа, а не запасной вариант к виджету.

export interface TelegramWebApp {
  initData: string
  ready: () => void
  expand?: () => void
  colorScheme?: 'light' | 'dark'
}

/**
 * Возвращает WebApp, только если мы действительно внутри Telegram.
 *
 * Проверяем непустоту `initData`, а не наличие объекта: скрипт SDK грузится
 * всегда и в обычном браузере тоже создаёт `window.Telegram.WebApp`, но с
 * пустой строкой. Без этой проверки обычный вход через браузер уходил бы в
 * ветку мини-приложения и упирался в 401.
 */
export function telegramWebApp(): TelegramWebApp | null {
  const tg = (window as unknown as { Telegram?: { WebApp?: TelegramWebApp } })
    .Telegram?.WebApp
  if (!tg || !tg.initData) return null
  return tg
}
